<template>
  <div class="confirmation-popup-overlay">
    <div class="confirmation-popup">
      <p>{{ message }}</p>
      <div v-if="showInput" class="input-group">
        <input 
          type="text" 
          v-model="localInputValue" 
          :placeholder="placeholder" 
          :maxlength="maxLength"
        />
      </div>
      <div class="button-group">
        <button @click="confirmAction">Bestätigen</button>
        <button @click="cancelAction">Abbrechen</button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
      modelValue: {
        type: String,
        default: ''
      },
      showInput: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        default: 'Eingabe hier...'
      },
      maxLength: {
        type: [Number, String],
        default: null
      }
    },
    data() {
      return {
        localInputValue: this.modelValue // Lokaler Wert für das Eingabefeld
      };
    },
    watch: {
      modelValue(newVal) {
        this.localInputValue = newVal;
      }
    },
    methods: {
      confirmAction() {
        this.$emit('update:modelValue', this.localInputValue); // Aktualisierung des Werts
        this.$emit('confirm', this.localInputValue);
      },
      cancelAction() {
        this.$emit('cancel');
      }
    }
  };
  </script>

<style scoped src="@/styles/ConfirmationDialog.css">

</style>